<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import CoreUI styles for this application
  @import 'assets/scss/style';
  // Extra styles for this application
  .kubesphere-icon {
    fill: #b6c2cd;
  }
  .c-sidebar-nav-icon {
    fill: #b6c2cd;
  }
</style>
